/* 🤖 this file was generated by svg-to-ts */
export const matIconAirplay: {
  name: 'airplay';
  data: string;
} = {
  name: 'airplay',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 22h12l-6-6z"/><path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>`
};
